import type { SlateBlock, HeadingOneBlock, HeadingTwoBlock, ParagraphBlock, HeadingThreeBlock } from '@atlas/renderer';

export default function isOneLineTextBlock(block: SlateBlock): block is OneLineTextBlock {
    return (ONE_LINE_TEXT_BLOCK_TYPES as Array<SlateBlock['type']>).includes(block.type);
}

// #region Helpers

export const ONE_LINE_TEXT_BLOCK_TYPES: Array<OneLineTextBlock['type']> = [
    'paragraph',
    'heading-one',
    'heading-two',
    'heading-three',
];

// #endregion

// #region Types

export type OneLineTextBlock = ParagraphBlock | HeadingOneBlock | HeadingTwoBlock | HeadingThreeBlock;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isOneLineTextBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
